import { Component } from "react";

import TableNew from "../../../../shared/Table";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import { getCompletedColumns, getPendingColumns } from "./AutogiroColumns";
import { autogiroConnector } from "../../../../services/autogiro/connector";
import { compose } from "redux";

class AutogiroPaymentsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    this.props.getPendingAutogiro();
    this.props.getCompletedAutogiro();
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.colsePendingDialog();
  };

  sendConfirm = () => {
    this.props.completeAllPendingAutogiroRequests();
  };

  getAdhocPayments = () => {
    var token = JSON.parse(localStorage.getItem("admin.usr"))["access_token"];
    var req = new XMLHttpRequest();
    req.open("POST", "/api/admin/loans/fullrepayment/file", true);
    req.responseType = "blob";
    req.setRequestHeader("Authorization", "Bearer " + token);
    req.setRequestHeader("Content-Type", "application/json");
    req.onload = () => {
      var blob = req.response;
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      var fileName = "BFEP.IAGAG.537531.180703.133827"; //req.getResponseHeader('Content-Disposition').match(/\sfilename="([^"]+)"(\s|$)/)[1];
      link.download = fileName;
      link.click();
    };
    req.send();
  };

  getResponseMsg = () => {
    let content;

    if (this.props.accounting.autogiroBulkApprove.send)
      content = <div>Applications were approved</div>;
    if (this.props.accounting.autogiroBulkApprove.sending)
      content = <CircularProgress />;
    if (this.props.accounting.autogiroBulkApprove.error)
      content = <div>{this.props.accounting.autogiroBulkApprove.error}</div>;

    return content;
  };

  render() {
    let loader = (
      <div>
        loading <CircularProgress />
      </div>
    );

    var responseMsg = this.getResponseMsg();

    var actions = responseMsg
      ? [
          <Button
            key="Ok"
            variant="outlined"
            color="primary"
            onClick={this.handleClose}
          >
            Ok
          </Button>,
        ]
      : [
          <Button key="cancel" variant="outlined" onClick={this.handleClose}>
            Cancel
          </Button>,
          <Button
            key="YesConfirm"
            variant="outlined"
            color="primary"
            onClick={this.sendConfirm}
          >
            Yes confirm
          </Button>,
        ];

    let pendingData = this.props.accounting.autogiroPending;
    let completedData = this.props.accounting.autogiroCompleted;

    let pendingContent = loader;
    let completedContent = loader;

    if (pendingData.fetched) {
      pendingContent = (
        <TableNew
          {...this.props}
          autogiroCompleteRequest={
            this.props.accounting.autogiroCompleteRequest
          }
          autogiroDeleteRequest={this.props.accounting.autogiroDeleteRequest}
          columns={getPendingColumns()}
          items={pendingData.data}
          actionColumnWidth={220}
          tableKey="PendingAutogiro"
        />
      );
    }

    if (completedData.fetched) {
      completedContent = (
        <TableNew
          {...this.props}
          columns={getCompletedColumns()}
          items={completedData.data}
          showDetails={true}
          actionColumnWidth={260}
          tableKey="completedAutogiro"
        />
      );
    }

    return (
      <div style={{ padding: "10px 25px" }}>
        {/* <p>
          Generating a payments file will include all pending and in progres requests<br />
          All pending requests will be set to in progress
        </p>
        <h3 style={{ whiteSpace: 'normal' }}>Get Payment File excluding users with Pending or InProgress Ad Hoc Requests</h3>
        <AutogiroToLoansTableButtons rows={pendingData.data} />
        <h3 style={{ whiteSpace: 'normal' }}>The Ad Hoc file must be downloaded between 16 and 18 for it to only include this days ad hoc payments.</h3>
        <Button variant="contained" color="primary"    primary={true} onClick={this.getAdhocPayments} >Get adhoc payments file</Button>
        <Button variant="contained" color="primary"    primary={true} onClick={this.handleOpen} style={{ marginLeft: '6px' }} >Confirm in progres requests</Button> */}
        <h3>Pending Requests:</h3>
        {pendingContent}
        <h3>Completed Requests:</h3>
        {completedContent}
        <Dialog title="Dialog With Actions" modal={true} open={this.state.open}>
          <DialogContent>
            <p>Are you sure you want to confirm all in progress requests?</p>
            <p />
            <p>{responseMsg}</p>
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default compose(autogiroConnector)(AutogiroPaymentsComponent);
